export const numOfFacesPerRow = 4;
export const maxRowInTooltip = 4;
export const faceSizeWidthPadding = 80;
